<template>
  <div>
    <div v-if="tabs.length > 1" class="px-3 border-b">
      <div class="lg:container overflow-x-scroll lg:overflow-visible">
        <div class="flex flex-nowrap gap-x-4 lg:justify-end">
          <template v-for="(tab, index) in tabs" :key="index">
            <UniversalLink
              :link="tab.link"
              class="whitespace-nowrap pb-2 pt-2.5 border-b-2 uppercase text-current"
              :class="[$route.name === tab.route.name ? 'border-action' : 'border-transparent']"
            >
              {{ tab.name }}
            </UniversalLink>
          </template>
        </div>
      </div>
    </div>

    <NuxtPage />
  </div>
</template>

<script setup lang="ts">
const { $sitewideConfig } = useNuxtApp()
const { isIntegrationEnabled } = useUtils()

// 404 if dealer locator is not enabled or googlePlaces is not enabled or geolocation is not enabled
if (!$sitewideConfig.config.dealerLocatorEnabled || !isIntegrationEnabled('googlePlaces'))
  throw createError({ statusCode: 404, statusMessage: 'Invalid URL', fatal: true })

const tabs = computed(() => {
  const tabs = [
    {
      name: 'Local Dealers',
      route: {
        name: 'dealer-locator',
      },
      link: '/dealer-locator',
    },
  ]

  if ($sitewideConfig.config.dealerLocatorInternationalEnabled) {
    tabs.push({
      name: 'International Dealers',
      route: {
        name: 'dealer-locator-international',
      },
      link: '/dealer-locator/international',
    })
  }

  if ($sitewideConfig.config.dealerLocatorOnlineEnabled) {
    tabs.push({
      name: 'Online Dealers',
      route: {
        path: '/online-dealers/',
      },
      link: '/online-dealers/',
    })
  }

  return tabs
})
</script>
